import AppBar from "./AppBar";

type LayoutProps = {
  children: React.ReactNode;
};

const Layout = ({ children }: LayoutProps) => {
  return <AppBar>{children}</AppBar>;
};

export default Layout;
